import { Button } from "@datamole/wds-component-button";
import { Card } from "@datamole/wds-component-card";
import { faTrash, faWrench } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";

import styles from "./entity-card.module.css";

import { useRole } from "@/features/auth/role.hooks";
import { InfoPopoverContext, UtilityTrigger } from "@/features/info-popover/popover.context";
import { storageService } from "@/features/storage/storage.service";
import { getUtilityLabel } from "@/features/storage/storage.utils";

type Props = {
    trigger: UtilityTrigger;
};

export const UtilityHeader = ({ trigger }: Props) => {
    const utility = storageService.getUtilityById(trigger.utilityId);
    if (!utility) return null;

    return (
        <Card.Header.Description>
            <Card.Header.Description.Title style={{ fontSize: 24 }}>
                <FontAwesomeIcon icon={faWrench} style={{ marginRight: 16, color: "var(--wds-color-primary-700)" }} />
                {getUtilityLabel(utility.type)}
            </Card.Header.Description.Title>
        </Card.Header.Description>
    );
};

export const UtilityCard = ({ trigger: _trigger }: Props) => {
    return <div className={styles.card_info}></div>;
};

export const UtilityActions = ({ trigger }: Props) => {
    const { setTrigger } = useContext(InfoPopoverContext);
    const { isAdmin } = useRole();

    if (!isAdmin) return null;

    const handleDelete = () => {
        if (confirm("Are you sure you want to remove this utility icon?")) {
            storageService.removeUtility(trigger.utilityId);
            setTrigger(null);
        }
    };

    return (
        <Button onClick={handleDelete}>
            <Button.Icon>
                <FontAwesomeIcon icon={faTrash} />
            </Button.Icon>
            <Button.Content>Remove</Button.Content>
        </Button>
    );
};
